<rx-modal-content [showCloseButton]="false" [headerCentered]="true" *transloco="let t; read: TRANSLATION_SCOPE">
  <h4 class="modal-title" data-qa="test-company-payment-add-payment-title">{{ t('title') }}</h4>
  <div class="modal-body d-flex flex-column align-items-center">
    <rx-alert
      *ngIf="companySettingsFacade.setupIntentError$ | async"
      type="danger"
      [message]="t('defaultError')"
      data-qa="test-company-payment-add-payment-error"
    />
    <rx-applications-payment-element
      *ngIf="companySettingsFacade.setupIntentClientSecret$ | async"
      data-qa="test-company-payment-add-payment-element"
      [stripe]="companySettingsFacade.stripe$ | async"
      [clientSecret]="companySettingsFacade.setupIntentClientSecret$ | async"
      [confirmButtonText]="t('confirmButton')"
      (savedSetupIntent)="onSavedSetupIntent($event)"
      (loadingError)="onLoadingError()"
    />
  </div>
</rx-modal-content>
